import './bmg-error-modal.scss';

import { Button, Modal } from '@/components/Shared/ui';

interface IProps {
  isOpened: boolean;
  onCancel: () => void;
  onRetry: () => void;
}

const BmgErrorModal: React.FC<IProps> = ({ isOpened, onCancel, onRetry }) => {
  return (
    <Modal
      title="Внимание!"
      className="bmg-error-modal"
      onClose={onCancel}
      open={isOpened}
      classNames={{
        container: 'bmg-error-modal__content'
      }}
      width={540}
      destroyOnHidden
      mask={{ closable: false }}
    >
      <div className="bmg-error-modal__body">
        <p className="bmg-error-modal__description">
          Указанный номер телефона не соответствует ИИН-у в базе мобильных
          граждан.
        </p>

        <p className="bmg-error-modal__steps-title">
          Для решения воспользуйтесь одним из способов:
        </p>

        <ol className="bmg-error-modal__steps">
          <li className="bmg-error-modal__step">
            Проверьте и обновите номер телефона в приложении{' '}
            <span className="bmg-error-modal__platform">eGov Mobile</span>{' '}
            (раздел «Мои данные» → «Контактные данные»)
          </li>
          <li className="bmg-error-modal__step">
            Обновите данные в личном кабинете на портале{' '}
            <span className="bmg-error-modal__platform">egov.kz</span>
          </li>
        </ol>
      </div>

      <div className="bmg-error-modal__actions">
        <Button
          type="button"
          className="bmg-error-modal__button"
          onClick={onCancel}
          fullWidth
        >
          Отмена
        </Button>
        <Button
          type="button"
          className="bmg-error-modal__button"
          onClick={onRetry}
          variant="filled-red"
          fullWidth
        >
          Попробовать снова
        </Button>
      </div>
    </Modal>
  );
};

export default BmgErrorModal;
